import { useState } from 'react';
import cx from 'classnames';
import { bool, func, node, shape, string } from 'prop-types';
import Header from './Header';
import OrderHeader from './OrderHeader';
import * as styles from './styles.module.scss';

const CollapsibleBar = ({
  openOnLoad = false,
  header = null,
  title = null,
  isDesktop = false,
  headerClickable = false,
  onClickOrderHeader = () => {},
  trackOrderViewed = () => {},
  children,
}) => {
  const [isOpen, setIsOpen] = useState(openOnLoad);
  const handleToggleOpen = () => {
    if (!isOpen) {
      if (trackOrderViewed) trackOrderViewed();
    }
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div
      className={cx(styles.collapsibleBarContainer, { [styles.isOpen]: isOpen })}
      data-testid="collapsible-bar-container"
    >
      {title && (
        <Header title={title} headerClickable={headerClickable} toggleOpen={handleToggleOpen} />
      )}
      {header && (
        <OrderHeader
          isDesktop={isDesktop}
          saleType={header.saleType}
          billingDate={header.billingDate}
          items={header.items}
          orderTotal={header.orderTotal}
          shippingAddress={header.shippingAddress}
          onClickHeader={onClickOrderHeader}
          toggleOpen={handleToggleOpen}
        />
      )}
      <div className={styles.content} data-testid="collapsible-bar-content">
        {children}
      </div>
    </div>
  );
};

CollapsibleBar.propTypes = {
  openOnLoad: bool,
  header: shape({}),
  title: string,
  isDesktop: bool,
  headerClickable: bool,
  onClickOrderHeader: func,
  trackOrderViewed: func,
  children: node.isRequired,
};

export default CollapsibleBar;
